interface BadgeNavigator {
  clearAppBadge?: () => Promise<void>;
  setAppBadge?: (count?: number) => Promise<void>;
}

export function syncAppBadge(count: number, target?: BadgeNavigator): void {
  const badgeNavigator =
    target ?? (typeof navigator === "undefined" ? null : (navigator as BadgeNavigator));
  if (!badgeNavigator) return;

  const operation =
    count > 0 ? badgeNavigator.setAppBadge?.(count) : badgeNavigator.clearAppBadge?.();
  void operation?.catch(() => undefined);
}
